<!-- 添加模板 -->
<template>
  <el-form
    ref="form"
    status-icon
    label-position="left"
    :model="template"
    :rules="rules"
    label-width="80px"
  >
    <el-form-item
      label="模板封面"
      prop="cover"
    >
      <el-upload
        class="cover-uploder"
        :action="uploadUrl"
        :show-file-list="false"
        with-credentials
        :on-success="handleCoverSuccess"
        :before-upload="beforeCoverUpload"
      >
        <img
          v-if="template.cover"
          :src="template.cover"
          class="cover-preview"
        >
        <i
          v-else
          class="el-icon-plus cover-uploder-icon"
        />
      </el-upload>
    </el-form-item>

    <el-form-item
      label="模板名称"
      prop="name"
    >
      <el-input v-model="template.name" />
    </el-form-item>

    <el-form-item
      label="模板标准"
      prop="standard"
    >
      <el-select
        v-model="template.standard"
        placeholder="请选择"
        value-key="standard-key"
      >
        <el-option
          label="HTML模板"
          value="html"
        />
        <el-option
          label="VUE单组件模板"
          value="vue-single-component"
        />
        <el-option
          label="React单组件模板"
          value="react-single-component"
        />
        <el-option
          label="fm VUE组件模板"
          value="fm-vue-component"
        />
      </el-select>
    </el-form-item>

    <!-- 如果模板标准选择了vue模板，则需要展示该项目 -->
    <el-form-item
      v-if="
        template.standard === 'vue-single-component' ||
          template.standard === 'react-single-component' ||
          template.standard === 'fm-vue-component'
      "
      label="组件名"
      prop="component"
    >
      <el-input
        v-model="template.component"
        type="input"
      />
    </el-form-item>

    <!-- 接口获取 -->
    <el-form-item
      label="模板类别"
      prop="categories"
    >
      <el-checkbox-group
        v-if="templateCotegories"
        v-model="template.categories"
      >
        <el-checkbox
          v-for="(item, prop) in templateCotegories"
          :key="prop"
          :label="prop"
        >
          {{ item }}
        </el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <el-form-item
      label="仓库地址"
      prop="repository"
    >
      <el-input v-model="template.repository" />
    </el-form-item>

    <el-form-item
      label="支持设备"
      prop="devices"
    >
      <el-checkbox-group v-model="template.devices">
        <el-checkbox
          label="mobile"
          checked
        >
          <i class="iconfont icon-iphone" />
        </el-checkbox>
        <el-checkbox
          label="pad"
          checked
        >
          <i class="iconfont icon-ipad" />
        </el-checkbox>
        <el-checkbox label="pc">
          <i class="iconfont icon-pc" />
        </el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <!-- 接口获取 -->
    <el-form-item
      label="模板类型"
      prop="types"
    >
      <el-checkbox-group
        v-if="templateTypes"
        v-model="template.types"
      >
        <el-checkbox
          v-for="(item, prop) in templateTypes"
          :key="prop"
          :label="prop"
        >
          {{ item }}
        </el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <el-form-item>
      <el-button
        type="primary"
        size="small"
        @click="submitForm('form')"
      >
        提交
      </el-button>
      <el-button
        size="small"
        @click="resetForm('form')"
      >
        取消
      </el-button>
    </el-form-item>
  </el-form>
</template>

<style lang="less">
@template-cover-width: 200px;
@template-cover-height: 112.3px;

#add-template-dialog,
#edit-template-dialog {
  .cover-uploder {
    width: @template-cover-width;
    height: @template-cover-height;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin: 0 auto 22px;
    text-align: center;
    line-height: @template-cover-height;

    // TODO 不生效
    .el-upload {
      display: block;
    }

    .cover-uploder-icon {
      font-size: 28px;
      color: #8c939d;
      vertical-align: middle;
    }

    .cover-preview {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .cover-uploder:hover {
    border-color: #ebb712;
  }

  .tempalte-tag {
    margin-right: 5px;
  }

  .input-new-template-tag {
    display: inline-block;
    height: 39px;
    width: 79px;
  }
}
</style>

<script>
const debug = require('debug')('ccs:ctrl:template_add');
import axios from 'axios';

export default {
	data() {
		return {
			uploadUrl: `${API_BASE_URL}/api/files`, /* eslint no-undef:0 */
			// 模板类别
			templateCotegories: {},
			// 模板类型
			templateTypes: {},

			// 添加/编辑 模板属性
			template: {
				name: '', // 模板名称
				cover: '', // 模板封面
				standard: '', // 模板标准
				repository: '', // 仓库地址
				component: '', // 组件名  如果standard是 vue-single-component必填
				categories: [], // 模板类别
				devices: [], // 支持设备
				types: [], // 模板类型（取值范围查看type取值）
			},

			rules: {
				name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
				cover: [
					{ required: true, message: '请选择模板封面', trigger: 'submit' },
				],
				standard: [
					{
						required: true,
						message: '请选择模板标准',
						trigger: 'change',
					},
				],
				repository: [
					{
						required: true,
						type: 'url',
						message: '请填写仓库地址',
						trigger: 'blur',
					},
				],
				categories: [
					{ required: true, message: '请选择模板类别', trigger: 'change' },
				],
				devices: [
					{
						required: true,
						message: '请选择支持的设备类型',
						trigger: 'change',
					},
				],
				tags: [
					{ required: true, message: '请选择模板标签', trigger: 'change' },
				],
				types: [
					{ required: true, message: '请选择模板类型', trigger: 'change' },
				],
			},
		};
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			this.templateCotegories = await axios.get('/api/templates/categories');
			this.templateTypes = await axios.get('/api/templates/types');
		},

		// 封面上传前置校验
		beforeCoverUpload(file) {
			debug('[beforeCoverUpload] file: %o', file);
			const isImg = file.type.startsWith('image');
			const isJPG = file.type === 'image/jpeg';
			const isPNG = file.type === 'image/png';
			const isLt200KB = file.size < 200 * 1024;

			if (!isJPG && !isPNG) {
				this.$message.error('上传封面图片只能是 JPG或PNG 格式!');
			}
			if (!isLt200KB) {
				this.$message.error('上传头像图片大小不能超过 200KB!');
			}
			return (isJPG || isPNG) && isLt200KB;
		},

		// 封面上传后
		handleCoverSuccess(res) {
			debug('[handleCoverSuccess] res: %o, file: %o', res);
			this.$set(this.template, 'cover', res.url);
		},
		// 提交模板
		async submitForm(formName) {
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					const template = this.template;
					await axios.post('/api/templates', template);

					this.template.name = '';
					this.template.cover = '';
					this.template.standard = '';
					this.template.repository = '';
					this.template.component = '';
					this.template.categories.splice(0, this.template.categories.length);
					this.template.types.splice(0, this.template.types.length);
					this.template.devices.splice(0, this.template.devices.length);
					// this.addTemplateDialogVisible = false;
					this.$emit('confirm', 1);
					return true;
				}
				return false;
			});
		},

		resetForm(formName) {
			this.$refs[formName].resetFields();
			// this.addTemplateDialogVisible = false;
			this.$emit('cancel', 0);
		},
	},
};
</script>
